import { PayBreakdownAdjustmentsTab } from "@/payroll/pay-breakdown/pay-breakdown-adjustments-tab";
import { PayBreakdownEmailsTab } from "@/payroll/pay-breakdown/pay-breakdown-emails-tab";
import { PayBreakdownPackChatTab } from "@/payroll/pay-breakdown/pay-breakdown-pack-chat-tab";
import { PayBreakdownPayPlanTab } from "@/payroll/pay-breakdown/pay-breakdown-pay-plan-tab";
import { PayBreakdownRosterTab } from "@/payroll/pay-breakdown/pay-breakdown-roster-tab";
import { PAY_BREAKDOWN_SECTION } from "@/payroll/pay-breakdown/types";
import type { PayBreakdownPageState } from "./use-pay-breakdown-page";

interface PayBreakdownSectionPanelsProps {
  page: PayBreakdownPageState;
}

export const PayBreakdownSectionPanels = ({
  page,
}: PayBreakdownSectionPanelsProps) => {
  const {
    businessId,
    selectedPeriodStart,
    business,
    isLocked,
    aiScriptRunId,
    canViewRoster,
    canViewPayPlan,
    showSectionTabs,
    activeSection,
    rosterVersionNumber,
    currentRosterVersionNumber,
  } = page;

  return (
    <>
      {showSectionTabs &&
        canViewRoster &&
        activeSection === PAY_BREAKDOWN_SECTION.roster &&
        businessId && (
          <PayBreakdownRosterTab
            businessId={businessId}
            runVersionNumber={rosterVersionNumber}
            currentVersionNumber={currentRosterVersionNumber}
            hasRun={!!aiScriptRunId}
          />
        )}
      {showSectionTabs &&
        canViewPayPlan &&
        activeSection === PAY_BREAKDOWN_SECTION.payPlan &&
        businessId &&
        aiScriptRunId && (
          <PayBreakdownPayPlanTab
            businessId={businessId}
            runId={aiScriptRunId}
            canEditRules={business?.can_edit_payroll_rules === true}
          />
        )}
      {showSectionTabs && activeSection === PAY_BREAKDOWN_SECTION.packs && (
        <PayBreakdownEmailsTab />
      )}
      {showSectionTabs && activeSection === PAY_BREAKDOWN_SECTION.packChat && (
        <PayBreakdownPackChatTab
          businessId={businessId}
          periodStart={selectedPeriodStart}
          runId={aiScriptRunId}
          isLocked={isLocked}
        />
      )}
      {showSectionTabs &&
        activeSection === PAY_BREAKDOWN_SECTION.adjustments && (
          <PayBreakdownAdjustmentsTab />
        )}
    </>
  );
};
